export default "__VITE_ASSET__8cfd5707__"